import { Flex } from '@chakra-ui/react';
import { useSearchParams } from 'react-router-dom';

import {
    AllocationVariant,
    useCashAllocationReport,
    usePreTradeAllocationReport,
    useSecuredAllocationReport,
} from '../api/allocation';
import { PageHeader } from '../widgets/PageHeader';
import { SegmentedControls } from '../widgets/SegmentedControls';
import { AsOfDateTag } from '../widgets/Table/AsOfDateTag';
import { CashAllocationList } from './CashAllocationTable';
import { PreTradeAllocationList } from './PreTradeAllocationTable';
import { SecuredAllocationList } from './SecuredAllocationTable';

export const AllocationList = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const dataVariant = (searchParams.get('dataVariant') || 'growth') as AllocationVariant;

    const { data: preTradeAllocationReportPage } = usePreTradeAllocationReport({
        pagination: { pageSize: 1, pageIndex: 0 },
    });
    const { data: securedAllocationReportPage } = useSecuredAllocationReport({
        pagination: { pageSize: 1, pageIndex: 0 },
    });
    const { data: cashAllocationReportPage } = useCashAllocationReport({ pagination: { pageSize: 1, pageIndex: 0 } });

    return (
        <>
            <PageHeader title="Allocation Report">
                <Flex flex={1} justifyContent="space-between" alignItems="center">
                    <SegmentedControls
                        onClick={(value) =>
                            setSearchParams((params) => {
                                params.set('dataVariant', value);
                                return params;
                            })
                        }
                        selectedValue={dataVariant}
                        options={[
                            { value: 'growth', label: 'Growth' },
                            { value: 'secured', label: 'Secured' },
                            { value: 'cash', label: 'Cash' },
                        ]}
                    />
                    {dataVariant === 'growth' && <AsOfDateTag dateString={preTradeAllocationReportPage?.asOfDate} />}
                    {dataVariant === 'secured' && <AsOfDateTag dateString={securedAllocationReportPage?.asOfDate} />}
                    {dataVariant === 'cash' && <AsOfDateTag dateString={cashAllocationReportPage?.asOfDate} />}
                </Flex>
            </PageHeader>
            {dataVariant === 'growth' && <PreTradeAllocationList />}
            {dataVariant === 'secured' && <SecuredAllocationList />}
            {dataVariant === 'cash' && <CashAllocationList />}
        </>
    );
};
